import { EventState, EventSubType, EventType, ExecuteEvent } from "pubsub/PubSub.const";
import IEvent from "./IEvent";
import { EventDto, IEventDto } from "pubsub/dto";
import { getInteractor } from "services/local.service";
import { refactorSavingEvent } from "pubsub/PubSub.helper";
import { deleteFileService, failedFileService, uploadedFileService } from "pubsub/services/file.service";

export default class FileEvent extends IEvent {
  constructor(prefixKey: string) {
    super(prefixKey, EventType.FILE);
  }

  override handleEvent = async (limitRetry: number) => {
    const eventList: EventDto[] = (
      await getInteractor(this.prefixKey).LocalEventService.find({
        type: this.eventType,
        state: [EventState.NEW, EventState.RESENT],
      })
    ).map((item: IEventDto) => new EventDto(item));
    const savingEvents: IEventDto[] = [];

    for (let index = 0; index < eventList.length; index++) {
      const eventItem = eventList[index];
      const eventContent = eventItem.contentObj;
      const accountId = eventContent.account_id;
      const attachmentId = eventContent.attachment_id;
      const groupId = eventContent.group_id;
      let executeEventValue: ExecuteEvent = ExecuteEvent.FAIL;

      if (accountId) {
        switch (eventItem.subtype) {
          case EventSubType.UPLOADED:
            executeEventValue = await uploadedFileService(this.prefixKey, groupId, attachmentId);
            break;

          case EventSubType.FAILED:
            executeEventValue = await failedFileService(this.prefixKey, groupId, attachmentId);
            break;

          case EventSubType.DELETE:
            executeEventValue = deleteFileService();
            break;

          default:
            break;
        }
      }

      // Update event before saving in local db
      const refactorEvent = refactorSavingEvent(eventItem, executeEventValue, limitRetry);
      if (refactorEvent) savingEvents.push(refactorEvent);
    }

    await getInteractor(this.prefixKey).LocalEventService.save(savingEvents);
    return true;
  };
}
